import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import BcTable from '@/components/Table.vue';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// @ts-ignore
import BcDialog from '@/components/Dialog.vue';
let ProductInventory = class ProductInventory extends Vue {
    constructor(props) {
        super(props);
        this.snackbar = new CBcSnackbar();
        this.headers = [];
        this.desserts = [];
        this.productList = [];
        this.comboboxProductList = [];
        this.listHospital = [];
        this.productCategory = [];
        this.storeTypeArray = [];
        this.inboundTypeArray = [
            '生产',
            '采购',
            '换货',
            '试用（换货）',
            '退库',
            '销售（换货）',
        ];
        this.outboundTypeArray = [
            '试用',
            '试用（换货）',
            '销售',
            '销售（换货）',
        ];
        this.loading = false;
        this.searchOptions = {
            keyword: '',
            displayOption: 0,
            timer: null,
            productLine: '',
            productModel: '',
        };
        this.pagination = {};
        this.dialogProduct = {
            visible: false,
            loading: false,
            title: '',
            operType: 'add',
            form: false,
            formData: {},
            products: [],
        };
        this.salesOrderDist = []; // 生产订单
        // 变量在构造函数内部进行声名赋值
        const that = this;
        that.headers = [
            {
                text: '产品线',
                align: 'left',
                sortable: false,
                value: 'productLine',
                width: '80',
            },
            {
                text: '产品类别',
                align: 'center',
                sortable: false,
                value: 'productType',
                width: '90',
            },
            {
                text: '设备编号',
                align: 'left',
                sortable: false,
                value: 'deviceCode',
                width: '150',
            },
            {
                text: '产品名称',
                align: 'left',
                sortable: false,
                value: 'productName',
                maxWidth: '260',
            },
            {
                text: '产品简称',
                align: 'center',
                sortable: false,
                value: 'productShortName',
                maxWidth: '120',
            },
            {
                text: '产品系列',
                align: 'center',
                sortable: false,
                value: 'serial',
                maxWidth: '115',
            },
            {
                text: '型号',
                align: 'left',
                sortable: false,
                value: 'model',
                maxWidth: '140',
            },
            {
                text: '规格',
                align: 'start',
                sortable: false,
                value: 'specifications',
            },
            {
                text: '库存单类型',
                align: 'center',
                sortable: false,
                value: 'storeType',
                width: '95',
            },
            {
                text: '来源/去向',
                align: 'center',
                sortable: false,
                value: 'boundType',
                width: '120',
            },
            {
                text: '出/入库时间',
                align: 'center',
                sortable: false,
                value: 'boundDate',
                width: '175',
            },
            {
                text: '出/入库数量',
                align: 'center',
                sortable: false,
                value: 'stockInOutQuantity',
                width: '100',
            },
            //   {
            //     text: "备注",
            //     align: "center",
            //     sortable: false,
            //     value: "remark",
            //   },
            {
                text: '操作',
                align: 'center',
                sortable: false,
                value: 'action',
                width: '105',
            },
        ];
        that.desserts = [];
        that.pagination = {
            pageCount: 1,
            pageNow: 1,
            pageArr: [5, 10, 20, 50, '所有'],
            everyPageCount: 1000,
            sumDetail: 0,
        };
        that.storeTypeArray = [
            {
                text: '全部',
                value: '',
            },
            {
                text: '入库',
                value: '0',
            },
            {
                text: '出库',
                value: '1',
            },
        ];
    }
    get formProductList() {
        const that = this;
        if ((that.productList || []).length == 0)
            return [];
        // 如果表单产品线没数据时依旧返回空
        if (!that.dialogProduct.formData.productLine)
            return [];
        return that.productList.filter((item) => item.productLine == that.dialogProduct.formData.productLine);
    }
    /**
     * 获取库存列表
     */
    async getDataList() {
        const that = this;
        that.loading = true;
        try {
            const res = await that.axios.get('/api/erp/inventory', {
                params: {
                    page: that.pagination.pageNow,
                    limit: typeof that.pagination.everyPageCount === 'number'
                        ? that.pagination.everyPageCount
                        : that.pagination.sumDetail,
                    keyword: that.searchOptions.keyword,
                    productLine: that.searchOptions.productLine,
                    productModel: (that.searchOptions.productModel || {}).model,
                    storeType: (that.searchOptions.storeType || {}).value,
                },
            });
            that.desserts = res.data.result || [];
            that.pagination.sumDetail = res.data.sum || 0;
            // 分页信息处理
            that.pagination.sumDetail = res.data.sum;
            const pageCount = Math.ceil(res.data.sum / that.pagination.everyPageCount) || 1;
            that.pagination.pageCount = pageCount;
            if (that.pagination.pageNow > pageCount) {
                that.pagination.pageNow = pageCount;
                that.getDataList();
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            that.loading = false;
        }
    }
    /**
     * 获取产品列表
     */
    async getProductList() {
        const that = this;
        const res = await that.axios.get('/api/erp/sales');
        that.productList = (res.data && res.data.result) || [];
        that.setComboboxProductList();
        that.productCategory = [];
        if (that.productList.length > 0) {
            // 去重后添加到产品线分类中
            const pList = that.productList.map((o) => o.productLine);
            that.productCategory = pList.filter((value, index, self) => self.indexOf(value) === index) || [];
        }
    }
    /**
     * 设置销售产品下拉框值
     */
    setComboboxProductList() {
        const { productList, dialogProduct, salesOrderDist } = this;
        if (!dialogProduct.formData.salesOrderId) {
            this.comboboxProductList = productList;
            return;
        }
        const sales = salesOrderDist.find((o) => o.id === dialogProduct.formData.salesOrderId);
        if (!sales || !sales.products) {
            this.comboboxProductList = [];
            return;
        }
        this.comboboxProductList = productList.filter((item) => sales.products.some((p) => p.model === item.model));
    }
    /*
     * 显示产品表单
     * @param operType 操作类型
     * @param row 行数据
     * */
    async showProductFormClick(operType, row) {
        const that = this;
        that.dialogProduct.visible = true;
        const dateField = ['inboundDate', 'outboundDate', 'deliveryDate'];
        that.dialogProduct.formData = Object.assign({}, row || {});
        that.dialogProduct.products = [];
        that.dialogProduct.operType = operType;
        if (row) {
            that.dialogProduct.formData.storeType = row.inboundType ? '0' : '1'; // 0-入库 1-出库
        }
        that.setComboboxProductList();
        await that.getSalesOrderDist();
        if (operType === 'add') {
            that.dialogProduct.title = '新增产品库存单';
            that.dialogProduct.formData = {
                storeType: '0',
            };
            const date = new Date();
            dateField.forEach((field) => {
                that.dialogProduct.formData[field] = date.format('yyyy-MM-dd hh:mm:ss');
                that.dialogProduct.formData[`${field}SelectedDate`] = date.format('yyyy-MM-dd');
                that.dialogProduct.formData[`${field}SelectedTime`] = date.format('hh:mm:00');
            });
        }
        else if (operType === 'edit') {
            that.dialogProduct.title = '修改产品库存单';
            dateField.forEach((field) => {
                if (!that.dialogProduct.formData[field])
                    return;
                const d = new Date(that.dialogProduct.formData[field]);
                that.dialogProduct.formData[field] = d.format('yyyy-MM-dd hh:mm:ss');
                that.dialogProduct.formData[`${field}SelectedDate`] = d.format('yyyy-MM-dd');
                that.dialogProduct.formData[`${field}SelectedTime`] = d.format('hh:mm:00');
            });
            if (that.dialogProduct.formData.productTypeInfoId) {
                const productTypeInfo = that.formProductList.find((o) => o.id == that.dialogProduct.formData.productTypeInfoId);
                const pRow = {};
                that.setProduct(productTypeInfo, pRow);
                // 数量、编号、入库类型单独设置
                pRow.stockInOutQuantity = that.dialogProduct.formData.stockInOutQuantity;
                pRow.outboundType = that.dialogProduct.formData.outboundType;
                pRow.inboundType = that.dialogProduct.formData.inboundType;
                pRow.deviceCode = that.dialogProduct.formData.deviceCode;
                that.dialogProduct.products.push(pRow);
            }
        }
        else {
            that.dialogProduct.title = '删除产品信息';
        }
    }
    /**
     * 添加产品容器
     */
    addProductContainer() {
        const that = this;
        if (that.dialogProduct.products.length > 0) {
            // 判断是否有为空的产品容器
            if (that.dialogProduct.products.findIndex((o) => (o.productTypeInfoId || '').length == 0) > -1) {
                that.snackbar.warn('请先填写完毕后添加产品.');
                return;
            }
        }
        that.dialogProduct.products.push({
            productTypeInfoId: '',
            productInfo: '',
            productLine: '',
            productType: '',
            productTypeName: '',
            deviceCode: '',
            productName: '',
            productShortName: '',
            serial: '',
            model: '',
            specifications: '',
            stockInOutQuantity: '',
            quantityUnit: '',
            boundType: '',
        });
        // 在添加控件后滚动到底部
        that.$nextTick(() => {
            that.$refs.refFormPro.$el.scrollTop = that.$refs.refFormPro.$el.scrollHeight;
        });
    }
    /**
     * 删除产品容器
     */
    delProductContainer(index) {
        const that = this;
        that.dialogProduct.products.splice(index, 1);
    }
    /**
     * 产品发生变更时
     */
    async productInfoChange(row) {
        const that = this;
        if (row && row.productInfo) {
            await that.setProduct(row.productInfo, row);
        }
    }
    /**
     * 设置产品值
     * @param productInfo
     * @param row
     */
    async setProduct(productInfo, row) {
        const that = this;
        row.productTypeInfoId = productInfo.id; // 产品id
        row.productInfo = productInfo; // 产品集合
        row.productLine = productInfo.productLine; // 产品线
        row.productType = productInfo.category; // 产品类别
        row.productTypeName = productInfo.category == 0 ? '独立设备' : '包装产品';
        row.deviceCode = ''; // 设备编号 实际
        row.productName = productInfo.productName; // 产品名称
        row.productShortName = productInfo.shortName; // 产品简称
        row.serial = productInfo.serial;
        row.model = productInfo.model;
        row.specifications = productInfo.specifications;
        row.stockInOutQuantity = 1; // 出/库数量默认为1，但是独立设备不运行修改
        row.quantityUnit = productInfo.unit;
        // 设置产品编号范围值
        // 获取产品编号信息，根据产品id获取
        const inverntoryProductList = await that.getInverntoryProductList({
            productTypeInfoId: productInfo.id,
        });
        console.log(123, inverntoryProductList);
        that.$set(row, 'inverntoryProductList', inverntoryProductList || []);
    }
    productFilter(item, queryText, itemText) {
        return (new RegExp(queryText.toUpperCase(), 'i').test(item['productName'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['model'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['shortName'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['orderNumber'] || ''));
    }
    /**
     * 保存日期时间
     * @param inputType
     */
    handleDateTimeSelection(inputType) {
        const that = this;
        const selectedDate = that.dialogProduct.formData[`${inputType}SelectedDate`];
        const selectedTime = that.dialogProduct.formData[`${inputType}SelectedTime`];
        if (selectedDate && selectedTime) {
            that.dialogProduct.formData[inputType] = `${selectedDate} ${selectedTime}:00`;
            that.dialogProduct.formData[`${inputType}Menu`] = false; // 关闭选择器菜单
        }
    }
    /**
     * 验证表单是否为入库单
     */
    isInventory() {
        const that = this;
        return (that.dialogProduct.formData.storeType || '0') === '0';
    }
    /**
     * 保存库存信息
     */
    async saveProductInventory() {
        const that = this;
        let forms = [];
        // 非删除库存时参数校验
        if (!(that.dialogProduct.operType == 'del')) {
            if (!that.$refs['refFormPro'].validate()) {
                that.snackbar.warn('请填写必要字段后重新保存.');
                return;
            }
            if ((that.dialogProduct.products || []).length === 0) {
                that.snackbar.warn('请添加产品后重新保存.');
                return;
            }
            forms = that.getInventoryFormInfo(that.dialogProduct.formData.storeType, that.dialogProduct.formData);
        }
        else {
            forms = [
                {
                    id: that.dialogProduct.formData.id,
                },
            ];
        }
        that.dialogProduct.loading = true;
        let month = '';
        let url = '/api/erp/inventory';
        let msg = '';
        // 添加
        if (that.dialogProduct.operType == 'add') {
            month = 'post';
            msg = '添加';
        }
        else if (that.dialogProduct.operType == 'edit') {
            forms = forms[0]; // 编辑只能单条编辑
            month = 'put';
            url += '/' + forms.id;
            msg = '修改';
        }
        else if (that.dialogProduct.operType == 'del') {
            forms = forms[0]; // 删除只能单条删除
            month = 'delete';
            url += '/' + forms.id;
            msg = '删除';
        }
        await that.axios[month](url, forms)
            .then((res) => {
            that.dialogProduct.loading = false;
            // 提示成功刷新页面
            that.dialogProduct.visible = false;
            that.snackbar.success(`${msg}库存信息成功`);
            that.getDataList();
        })
            .catch((e) => {
            that.dialogProduct.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`${msg}库存信息错误${resMeg}`);
            console.log(`${msg}库存信息错误`, e);
        });
    }
    /**
     * 获取库存表单信息
     * storeType :0-入库 1-出库
     */
    getInventoryFormInfo(storeType, formData) {
        const that = this;
        if (!formData)
            return [];
        const forms = [];
        // 这里组装批量入库或出库信息
        that.dialogProduct.products.forEach((item) => {
            // 公共字段
            const data = {
                productLine: item.productLine,
                productTypeInfoId: (item.productInfo || {}).id,
                productType: item.productType,
                productName: item.productName,
                productShortName: item.productShortName,
                serial: item.serial,
                model: item.model,
                specifications: item.specifications,
                stockInOutQuantity: item.stockInOutQuantity,
                remark: formData.remark,
                deviceCode: item.deviceCode,
            };
            if (formData.id)
                data.id = formData.id;
            // 入库
            if (storeType == '0') {
                data.inboundType = item.inboundType;
                data.inboundDate = formData.inboundDate;
                // 处理生产订单信息
                data.salesOrderId = formData.salesOrderId;
                data.salesOrderType = '';
                data.salesOrderNumber = '';
                if (formData.salesOrderId) {
                    const salesOrder = that.salesOrderDist.find((o) => o.id == formData.salesOrderId);
                    data.salesOrderType = salesOrder && salesOrder.orderType;
                    data.salesOrderNumber = salesOrder && salesOrder.orderNumber;
                }
            }
            else {
                // 出库
                data.hospitalId = formData.hospitalId || '';
                data.salesOrderId = formData.salesOrderId || '';
                data.salesOrderType = formData.salesOrderType;
                data.salesOrderNumber = formData.salesOrderNumber;
                data.deliveryDate = formData.deliveryDate;
                data.outboundType = item.outboundType;
                data.usageLocation = formData.usageLocation;
                data.outboundDate = formData.outboundDate;
            }
            forms.push(data);
        });
        return forms;
    }
    /**
     * 获取医院集合
     */
    async getHospitalList() {
        const that = this;
        // 只需要触发一次
        if ((that.listHospital || []).length > 0) {
            return;
        }
        try {
            const ret = await that.axios
                .get('/api/hospital', { params: { simple: true } })
                .then((res) => {
                that.listHospital = (res && res.data && res.data.result) || [];
                return res;
            });
            return ret;
        }
        catch (e) {
            // that.snackbar.error('数据加载失败，请尝试重新查询');
            throw e;
        }
    }
    /**
     * 获取产品库存列表
     */
    async getInverntoryProductList(params) {
        const that = this;
        try {
            const ret = await that.axios.get('/api/erp/inventory/product', {
                params: params,
            });
            return (ret && ret.data && ret.data.result) || [];
        }
        catch (e) {
            // that.snackbar.error('数据加载失败，请尝试重新查询');
            throw e;
        }
    }
    /**
     * 查询数据
     */
    searchChange() {
        const that = this;
        clearTimeout(that.searchOptions.timer);
        that.searchOptions.timer = setTimeout(() => {
            that.getDataList();
        }, 300); // 1秒执行一次获取函数 防抖
    }
    /**
     * 获取生产订单字典数据
     */
    async getSalesOrderDist() {
        const that = this;
        // 只需要触发一次
        if ((that.salesOrderDist || []).length > 0) {
            return;
        }
        try {
            const ret = await that.axios
                .get('/api/erp/order/sales', {
                params: {
                    isQueryDist: true,
                    withProducts: true,
                },
            })
                .then((res) => {
                that.salesOrderDist = (res && res.data && res.data.result) || [];
                console.log(res.data.result);
                return res;
            });
            return ret;
        }
        catch (e) {
            // that.snackbar.error('数据加载失败，请尝试重新查询');
            throw e;
        }
    }
    /**
     * 生产订单列表查询，如果后续数据量过大这里需要做远程搜索
     * @param item
     * @param queryText
     * @param itemText
     */
    salesOrderFilter(item, queryText, itemText) {
        return (new RegExp(queryText.toUpperCase(), 'i').test(item['customerName'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['orderNumber'].toUpperCase()));
    }
    async mounted() {
        const that = this;
        await that.getHospitalList();
        that.getProductList();
        that.getDataList();
    }
};
ProductInventory = __decorate([
    Component({
        name: 'ProductInventory',
        components: {
            BcSnackbar,
            BcDialog,
            BcTable,
        },
    })
], ProductInventory);
export default ProductInventory;
